
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $ab67f75d678fc58a$exports = {};
var $52d91120c6fadd98$exports = {};
$52d91120c6fadd98$exports = import.meta.resolve("ipH9W");


$ab67f75d678fc58a$exports = {
    "summer-tour": $52d91120c6fadd98$exports
};


function $b3f620544982eb15$var$initHomeCarousel() {
    console.log('Flyer Images Glob Raw:', (0, (/*@__PURE__*/$parcel$interopDefault($ab67f75d678fc58a$exports))));
    const track = document.querySelector('.carousel-track');
    const dotsNav = document.querySelector('.carousel-dots');
    const trackContainer = document.querySelector('.carousel-track-container');
    const carouselContainer = document.querySelector('.carousel-container');
    // Clear existing hardcoded content
    track.innerHTML = '';
    dotsNav.innerHTML = '';
    const syncCarouselHeight = ()=>{
        const currentSlide = track.querySelector('.current-slide');
        if (!currentSlide) return;
        const img = currentSlide.querySelector('.tour-flyer-image');
        if (!img?.naturalWidth) return;
        const containerWidth = carouselContainer.clientWidth;
        const height = containerWidth * (img.naturalHeight / img.naturalWidth);
        trackContainer.style.height = `${height}px`;
    };
    const bindImageLoad = (img)=>{
        const onReady = ()=>{
            if (img.closest('.current-slide')) syncCarouselHeight();
        };
        if (img.complete) onReady();
        else img.addEventListener('load', onReady);
    };
    // Recursively find strings in the glob object
    const findUrls = (obj)=>{
        let urls = [];
        for(const key in obj){
            if (typeof obj[key] === 'string') urls.push(obj[key]);
            else if (typeof obj[key] === 'object' && obj[key] !== null) urls = urls.concat(findUrls(obj[key]));
        }
        return urls;
    };
    const flyerUrls = findUrls((0, (/*@__PURE__*/$parcel$interopDefault($ab67f75d678fc58a$exports))));
    console.log('Detected Flyer URLs:', flyerUrls);
    if (flyerUrls.length === 0) return;
    const nextButton = document.getElementById('next-btn');
    const prevButton = document.getElementById('prev-btn');
    const hasMultipleFlyers = flyerUrls.length > 1;
    if (hasMultipleFlyers) carouselContainer.classList.add('carousel-container--multiple');
    // Build slides and dots dynamically
    flyerUrls.forEach((url, index)=>{
        // Create Slide
        const li = document.createElement('li');
        li.className = `carousel-slide ${index === 0 ? 'current-slide' : ''}`;
        li.innerHTML = `
            <a href="/tour.html">
                <img src="${url}" alt="Tour Flyer" class="tour-flyer-image">
            </a>
        `;
        track.appendChild(li);
        bindImageLoad(li.querySelector('.tour-flyer-image'));
        if (hasMultipleFlyers) {
            const dot = document.createElement('button');
            dot.className = `carousel-dot ${index === 0 ? 'active' : ''}`;
            dotsNav.appendChild(dot);
        }
    });
    const slides = Array.from(track.children);
    const dots = Array.from(dotsNav.children);
    let currentIndex = 0;
    const updateCarousel = (index)=>{
        if (!hasMultipleFlyers) return;
        if (index < 0) index = slides.length - 1;
        if (index >= slides.length) index = 0;
        const currentSlide = track.querySelector('.current-slide');
        const targetSlide = slides[index];
        const currentDot = dotsNav.querySelector('.active');
        const targetDot = dots[index];
        currentSlide.classList.remove('current-slide');
        targetSlide.classList.add('current-slide');
        if (currentDot && targetDot) {
            currentDot.classList.remove('active');
            targetDot.classList.add('active');
        }
        currentIndex = index;
        syncCarouselHeight();
    };
    window.addEventListener('resize', syncCarouselHeight);
    if (window.ResizeObserver) {
        const resizeObserver = new ResizeObserver(()=>syncCarouselHeight());
        resizeObserver.observe(carouselContainer);
    }
    if (hasMultipleFlyers) {
        nextButton.addEventListener('click', ()=>updateCarousel(currentIndex + 1));
        prevButton.addEventListener('click', ()=>updateCarousel(currentIndex - 1));
        dotsNav.addEventListener('click', (e)=>{
            const targetDot = e.target.closest('button');
            if (!targetDot) return;
            const targetIndex = dots.indexOf(targetDot);
            updateCarousel(targetIndex);
        });
        setInterval(()=>updateCarousel(currentIndex + 1), 5000);
    }
}
document.addEventListener('DOMContentLoaded', $b3f620544982eb15$var$initHomeCarousel);


//# sourceMappingURL=path0.b8d05ad7.js.map
